import { useEffect, useState, type ReactElement } from 'react'
import { BrowserRouter } from 'react-router-dom'
import i18n from './i18n/config'
import { AuthProvider } from './hooks'
import { ThemeProvider } from './contexts/ThemeContext'
import { DemoModeProvider } from './contexts/DemoModeContext'
import { ListInvalidationProvider } from './hooks/use-list-invalidation'
import { DemoModeBanner } from './components/DemoModeBanner'
import { AppRoutes } from './app/AppRoutes'

function App(): ReactElement {
  const [language, setLanguage] = useState(i18n.language)
  useEffect(() => {
    const onLanguageChanged = (lng: string): void => {
      setLanguage(lng)
    }
    i18n.on('languageChanged', onLanguageChanged)
    return () => {
      i18n.off('languageChanged', onLanguageChanged)
    }
  }, [])

  return (
    <ThemeProvider>
      <ListInvalidationProvider>
        <AuthProvider key={language}>
          <DemoModeProvider>
            <BrowserRouter>
              <DemoModeBanner />
              <AppRoutes />
            </BrowserRouter>
          </DemoModeProvider>
        </AuthProvider>
      </ListInvalidationProvider>
    </ThemeProvider>
  )
}

export default App
